const ProjectDetailsSkeleton = () => (
  <div className="container mx-auto px-4 py-8 max-w-4xl animate-pulse">
    {/* Back button skeleton */}
    <div className="mb-6 flex items-center gap-2">
      <div className="w-24 h-6 bg-gray-200 dark:bg-gray-700 rounded"></div>
    </div>

    {/* Header skeleton */}
    <div className="mb-8">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div>
          <div className="w-64 h-8 bg-gray-200 dark:bg-gray-700 rounded mb-4"></div>
          <div className="flex items-center gap-2">
            <div className="w-20 h-6 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
        </div>
        <div className="flex gap-4">
          <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
          <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
        </div>
      </div>
    </div>

    {/* Main image skeleton */}
    <div className="mb-8">
      <div className="w-full h-[400px] bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
    </div>

    {/* Technologies skeleton */}
    <div className="mb-8">
      <div className="w-48 h-8 bg-gray-200 dark:bg-gray-700 rounded mb-4"></div>
      <div className="flex flex-wrap gap-2">
        {[1, 2, 3].map(i => (
          <div
            key={i}
            className="w-24 h-8 bg-gray-200 dark:bg-gray-700 rounded-full"
          ></div>
        ))}
      </div>
    </div>

    {/* Description skeleton */}
    <div className="mb-8">
      <div className="w-48 h-8 bg-gray-200 dark:bg-gray-700 rounded mb-4"></div>
      <div className="space-y-3">
        <div className="w-full h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="w-full h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="w-3/4 h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
      </div>
    </div>

    {/* Gallery skeleton */}
    <div className="mb-8">
      <div className="w-48 h-8 bg-gray-200 dark:bg-gray-700 rounded mb-4"></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[1, 2, 3, 4].map(i => (
          <div key={i}>
            <div className="w-full h-48 bg-gray-200 dark:bg-gray-700 rounded-lg mb-2"></div>
            <div className="w-3/4 h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ProjectDetailsSkeleton;
